import { useNavigate } from "react-router-dom";
import { showError } from "../../constants/toasts";
import { useEffect, useState } from "react";
import { useLazyGetCmsQuery } from "../../service/main";
import Loader from "../../constants/Loader";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [getCms] = useLazyGetCmsQuery();
  const [loading, setLoading] = useState(false);
  const [cmsData, setCmsData] = useState<{ privacyPolicy: string }>({
    privacyPolicy: "",
  });
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await getCms({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCmsData(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>Privacy Policy</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Privacy Policy
        </p>
      </div>
      <div className="cards terms">
        <p>{cmsData?.privacyPolicy || "No data found"}</p>
      </div>
    </>
  );
};
export default PrivacyPolicy;
